import axiosInstance from './config/api';

type Agent = {
    name: string;
    status: string;
    calls_taken_today: number;
    id: string;
};

export type ManagerCenterDataParams = {
    startDate: Date;
    endDate: Date;
};

/**
 * The projection's raw inputs, returned so the card can show the assumptions behind the
 * number rather than a bare figure.
 */
export type CapacityProjectionInputs = {
    active_agents: number;
    calls_to_agent_ratio: number;
    operating_minutes_per_day: number;
    /** 'workflow' when read from configured operating hours, 'default' when the 8h fallback. */
    operating_hours_source: 'workflow' | 'default' | string;
    avg_handle_time_minutes: number;
    /** What the handle time measures. 'talk_time_only' today: no wrap / after-call-work field exists. */
    avg_handle_time_basis: string;
    contact_rate_pct: number;
    active_workflows: number;
    sample_calls: number;
    window_days: number;
};

/**
 * FR-3.2 capacity block. `available` is false when there is no basis for a projection at all,
 * in which case both figures are zeroed; `inputs` is populated either way, and
 * `active_workflows` tells the UI which of the two reasons applies.
 */
export type CapacityProjection = {
    projected_daily_calls: number;
    projected_contacts: number;
    available: boolean;
    inputs: CapacityProjectionInputs;
};

export type ManagerCenterData = {
    metrics: {
        calls_taken: number;
        online_agents: number;
    };
    agents: Agent[];
    /** Omitted when the backend could not build the block at all (its queries degraded). */
    capacity_projection?: CapacityProjection;
};

export const getManagerCenterData = async (params: ManagerCenterDataParams) => {
    return await axiosInstance
        .get<ManagerCenterData>('/manager-command-center/dashboard', { params })
        .then((res) => res.data);
};
